// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2UQyS","header":"ReportDetails_header__1Apup","title":"ReportDetails_title__2xavS","left":"ReportDetails_left__10Gv9"};